import { Observable } from 'rxjs';

export interface ComponentAvailability {
    checked: boolean;
    available: boolean;
}

export interface ComponentsState {
    fullDoor: ComponentAvailability;
    activeSash: ComponentAvailability;
    passiveSash: ComponentAvailability;
    frame: ComponentAvailability;
    threshold: ComponentAvailability;
    hardware: ComponentAvailability;
    sideLight: {
        left: ComponentAvailability;
        right: ComponentAvailability;
        top: ComponentAvailability;
    };
    extension: {
        left: ComponentAvailability;
        right: ComponentAvailability;
        top: ComponentAvailability;
    };
    bottomExtension: ComponentAvailability;
    portal: ComponentAvailability;
    casing: ComponentAvailability;
    accessories: ComponentAvailability;
    pull: ComponentAvailability;
    recessedPull: ComponentAvailability;
}

/**
 * Abstrakcyjna klasa bazowa dla serwisu zarządzającego komponentami drzwi.
 * Używana przez @icc/configurator/ui do opcjonalnej integracji z konfiguratorem drzwi.
 */
export abstract class ComponentsServiceBase {
    abstract componentsState$: Observable<ComponentsState>;
    abstract getCurrentState(): ComponentsState;
    abstract updateComponentsFromConfiguration(components: any): void;
}
